import { useEditor, useNode } from "@craftjs/core";
import { ReactNode } from "react";

interface TextContainerProps {
    children: ReactNode;
}

const HomeButtonContainer = ({ children }: Partial<TextContainerProps>) => {
    const {
        connectors: { connect },
    } = useNode();

    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    if (enabled && !children)
        return (
            <div ref={(ref) => connect(ref!)} className="w-full p-3 bg-gray-200 rounded animate-pulse">
                This is an empty button container, add a 'Button' component here.
            </div>
        );

    return (
        <div ref={(ref) => connect(ref!)} className="flex flex-col gap-6">
            {children}
        </div>
    );
};

export default HomeButtonContainer;

HomeButtonContainer.craft = {
    displayName: "Container",
    rules: {
        canDrag: () => false,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        canDrop: (_: any, currentNode: any) => currentNode.data.name === "HomeButton",
    },
};
